import Vue from 'vue'
import { DataService } from '@/services/DataService.js'
export const namespaced = true

export const state = {
  currencies: [],
  units: []
}

export const mutations = {
  SET (state, [prop, val]) {
    Vue.set(state, prop, val)
  }
}

export const getters = {
  currencies: state => state.currencies,
  currencу: state => id => state.currencies.find(c => c.id === id),
  units: state => state.units,
  unit: state => id => state.units.find(u => u.id === id)
}

export const actions = {
  async load ({ commit, rootGetters }) {
    DataService.getUnits({ offset: 0, limit: 1000 }).then(({ data: { unit: { data, totalCount } } }) => {
      commit('SET', ['units', data])
    })
    DataService.getCurrencies({ offset: 0, limit: 1000 }).then(({ data: { currency: { data, totalCount } } }) => {
      commit('SET', ['currencies', data])
    })
  }
}
